import {AiFillCar} from "react-icons/ai";
import {FaMotorcycle, FaRoad} from "react-icons/fa6";
import {GiScooter} from "react-icons/gi";
import {US, NL} from "country-flag-icons/react/3x2";


export const courseIcon = (id_or_name) => {
    switch(id_or_name) {
        case 1:
        case 'Auto':
        case 'BTH':
            return <AiFillCar />
        case 2:
        case 'Motor':
        case 'ATH':
            return <FaMotorcycle />
        case 3:
        case 'Scooter':
        case 'Brommer':
        case 'AMTH':
            return <GiScooter />
        default:
            return <FaRoad />
    }
}
export const localeIcon = (locale) => {
    switch(locale) {
        case 'en':
            return <US className="country-flag" />
        case 'nl':
            return <NL className="country-flag" />
        default:
            return null
    }
}
export const localeName = (locale) => {
    switch(locale) {
        case 'en':
            return 'English';
        case 'nl':
            return 'Nederlands';
        default:
            return locale
    }
}
export function isCorrectAnswer(q) {
    var correct = 0;
    if(q.type === 'puzzle') {
        if (Object.keys(q.answer).length !== q.meta.length) return false;

        for (let i = 0; i < q.meta.length; i++) {
            if (q.answer[i] !== i + 1) return false;
        }
        return true;
    }
    if(q.type === 'manual') {
        var manualAnswer = q.answer
        q.correct.forEach((answer, idx) => {
            if(answer.toLowerCase().trim() == manualAnswer.toLowerCase().trim())
                correct++;
        });

        return correct > 0;
    }
    q.answer.forEach((answer, idx) => {
        if(q.correct.indexOf(answer) !== -1)
            correct++;
    });

    return correct === q.correct.length
}
export function format_seconds(inputSeconds, no_seconds) {
    let secondsInAMinute = 60;
    let secondsInAnHour  = 60 * secondsInAMinute;
    let secondsInADay    = 24 * secondsInAnHour;

    // extract days
    let days = Math.floor(inputSeconds / secondsInADay);

    // extract hours
    let hourSeconds = inputSeconds % secondsInADay;
    let hours = Math.floor(hourSeconds / secondsInAnHour);

    // extract minutes
    let minuteSeconds = hourSeconds % secondsInAnHour;
    let minutes = Math.floor(minuteSeconds / secondsInAMinute);

    // extract the remaining seconds
    let remainingSeconds = minuteSeconds % secondsInAMinute;
    let seconds = Math.ceil(remainingSeconds);

    // return the final array
    let obj = {
        d: days,
        h: hours,
        i: minutes,
        s: seconds
    }

    let out = [];
    if(obj['d'] > 1)
        return obj['d'] + ' days';
    else if(obj['d'] === 1)
        return obj['d'] + ' day';

    if(obj['h'] > 0)
        out.push(obj['h'] + 'h')
    if(obj['i'] > 0 || obj['h'] > 0)
        out.push(obj['i'] + 'm')

    if(!no_seconds && obj['s'] > 0)
        out.push(obj['s'] + 's');

    return out.join(' ')
}